<template>
	<div class="product-radio-select" :class="theme">
		<div
			@click="handleChange(product)"
			v-for="product in products"
			:key="product.id"
			class="product-radio-select__item product-item"
			:class="{ active: product.id == active.id }"
		>
			<div class="product-item__radio">
				<img src="@/assets/checked.svg" alt="" />
			</div>
			<div class="product-item__label">{{ product.text }}</div>
			<div v-if="product.badge" class="product-item__badge">{{ product.badge }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		products: {
			type: Array,
			required: true
		},
		active: {
			type: Object,
			required: true
		},
		theme: {
			type: String,
			validator: (value) => ['light', 'dark', 'yellow'].includes(value),
			default: 'light'
		}
	},

	setup(props, { emit }) {
		const handleChange = (product) => emit('select', product)

		return {
			handleChange
		}
	}
}
</script>

<style lang="scss" scoped>
.product-radio-select {
	&.light {
		--item-bg: #ffffff;
		--text-color: #323653;
		--badge-color: #ff4f7a;
		--check-icon-active-color: #7d8bf7;
		--check-icon-border-color: #979aaa;
	}

	&.dark {
		--item-bg: #252736;
		--text-color: #ffffff;
		--badge-color: #ff4f7a;
		--check-icon-active-color: #98a4ff;
		--check-icon-border-color: #737587;
	}

	&.yellow {
		--item-bg: #ffffff;
		--text-color: #323653;
		--badge-color: #e3484b;
		--check-icon-active-color: #daa365;
		--check-icon-border-color: #979aaa;
	}
}

.product-item {
	height: 54px;
	background-color: var(--item-bg);
	color: var(--text-color);
	display: flex;
	align-items: center;
	padding: 1rem 1.1rem;
	border-radius: 2rem;
	margin-bottom: 0.86rem;
	position: relative;
	cursor: pointer;

	&:last-child {
		margin-bottom: 0;
	}

	&__radio {
		width: 1.4rem;
		height: 1.4rem;
		border-radius: 50%;
		border: 1px solid var(--check-icon-border-color);
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			width: 0.8rem;
			display: block;
			opacity: 0;
		}
	}

	&__label {
		margin-left: 0.56rem;
	}

	&__badge {
		margin-left: auto;
		color: #fff;
		background-color: var(--badge-color);
		font-size: 0.8rem;
		font-weight: 700;
		padding: 0.14rem 0.6rem;
		border-radius: 0.9rem;
		white-space: nowrap;
	}

	&.active {
		.product-item__radio {
			background-color: var(--check-icon-active-color);
			border-color: var(--check-icon-active-color);

			img {
				opacity: 1;
			}
		}
	}
}
</style>
